import { appUrl } from 'utils/wrappers';

import Base from 'app/collections/base';
import CarrierAccount from 'app/models/carrier_account';

export const FILTER_BY_KEYS = ['readable', 'id', 'description'];

export default Base.extend({
  model: CarrierAccount,
  url: appUrl('carrier_accounts'),
  comparator: 'readable',

  filtered() {
    if (this.filterTerm) {
      const term = this.filterTerm.toLowerCase();

      return this.filter(model => (
        FILTER_BY_KEYS.reduce((str, key) => `${str} ${model.get(key)}`, '').toLowerCase().indexOf(term) > -1
      ));
    }

    return this.models;
  },
});



// WEBPACK FOOTER //
// ./app/collections/carrier_accounts.js